import User from '../../type/User';
import userDisplayName from '../formatter/userDisplayName';

const userSelectOptionMapper = (user: Pick<User, 'id' | 'username' | 'fullName'>) => ({
  label: userDisplayName(user),
  value: user.id,
});

export default userSelectOptionMapper;
